import { getDirectCalendar } from "../../../api";

export const fetchDirectCalendar = async ({
  widgetConfigurationId,
  date,
  discipline = null,
  competitionIds = [],
  hasCompetitionIdsParam = false,
}) => {
  const { data } = await getDirectCalendar({
    widgetConfigurationId,
    date,
    discipline,
    competitionIds,
    hasCompetitionIdsParam,
  });

  return data;
};